import { render, staticRenderFns } from "./vDragAndDropUpload.vue?vue&type=template&id=4ef137f7&scoped=true"
import script from "./vDragAndDropUpload.vue?vue&type=script&lang=js"
export * from "./vDragAndDropUpload.vue?vue&type=script&lang=js"
import style0 from "./vDragAndDropUpload.vue?vue&type=style&index=0&id=4ef137f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef137f7",
  null
  
)

export default component.exports